
















import { Component, Mixins, Prop } from 'vue-property-decorator';
import { EventBus } from '@/event-bus';
import TextAreaField from '@/components/TextAreaField.vue';
import TextFieldElementMixin from '@/mixins/textFieldElementMixin';
import TextFieldsWrapper from '@/components/TextFieldsWrapper.vue';
import { WIDGET_EVENTS } from '@/const/widget-events';

@Component({
  components: {
    TextAreaField,
    TextFieldsWrapper,
  },
})
export default class TextAreaElementWidget extends Mixins(
  TextFieldElementMixin
) {
  @Prop({ type: Boolean, default: false }) isNested?: boolean;

  private changeHandler(value: string) {
    const eventBody = {
      field: this.field,
      value: value ? value : null,
    };
    if (this.isNested) {
      this.$emit(WIDGET_EVENTS.CHANGE, eventBody);
      return;
    }
    EventBus.$emit(WIDGET_EVENTS.CHANGE, eventBody);
  }
}
